export const LIB_VERSION = '14.1.0'; // autogenerated
//# sourceMappingURL=version.js.map